import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { GetAllAccessibleStudiesResponse, GetAllCrcAccessibleStudiesResponse } from '@app/generated-api';
import { StudyServiceV2 } from '@app/v2/services/study/study.service';
import { UserServiceV2 } from '@app/v2/services/user-service/user.service';
import { MedpaceTableComponent } from '@components/molecules/table/table.component';
import { MedpaceFieldMap } from '@models/medpace-field-map';
import { map, take } from 'rxjs';

@Component({
    selector: 'medpace-active-studies-table',
    imports: [MedpaceTableComponent, AsyncPipe],
    templateUrl: './active-studies-table.component.html',
    styleUrl: './active-studies-table.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActiveStudiesTableComponent {
    private readonly studyService = inject(StudyServiceV2);
    private readonly userService = inject(UserServiceV2);
    private readonly router = inject(Router);

    hasPermissionToMainDashboard$ = this.userService.hasAllPermissions$(['dashboard.main.page.view']);
    hasPermissionToCrcDashboard$ = this.userService.hasAllPermissions$(['dashboard.crc.page.view']);

    ///CRC///

    crcColumnMap: MedpaceFieldMap[] = [
        { header: 'Sponsor Name', name: 'sponsor' },
        { header: 'Protocol', name: 'protocol' },
        { header: 'Indication', name: 'indication' },
        { header: 'ClinTrak Status', name: 'status' },
        { header: 'Requests', name: 'requests' },
    ];
    crcColumns: string[] = this.crcColumnMap.map((fieldMap) => fieldMap.name);

    crcActiveStudies$ = this.studyService.getAllCrcStudySummaries().pipe(
        take(1),
        map((result) => {
            result.forEach((study) => {
                study.indication = study.indication || 'N/A';
                study.status = study.status || 'N/A';
            });
            return result;
        })
    );

    ///MAIN///

    otherStudiesColumnMap: MedpaceFieldMap[] = [
        { header: 'Sponsor Name', name: 'sponsor' },
        { header: 'Protocol', name: 'protocol' },
        { header: 'Indication', name: 'indication' },
        { header: 'ClinTrak Status', name: 'status' },
        { header: '# Sites', name: 'numSites' },
        { header: '# Patients', name: 'numPatients' },
        { header: 'Requests', name: 'requests' },
    ];
    otherStudiesColumns: string[] = this.otherStudiesColumnMap.map((fieldMap) => fieldMap.name);

    mainActiveStudies$ = this.studyService.getAllStudySummaries().pipe(
        take(1),
        map((result) => {
            result.forEach((study) => {
                study.indication = study.indication || 'N/A';
                study.status = study.status || 'N/A';
            });
            return result;
        })
    );

    ///BOTH///
    doClickRow(event: GetAllAccessibleStudiesResponse | GetAllCrcAccessibleStudiesResponse) {
        this.router.navigate([`studies/${event.id}`], { state: event });
    }
}
